<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="pd-10 bg-white">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="电话号码">
          <el-input
            v-model="form.phone"
            clearable
            placeholder="请输入电话号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="预警类型">
          <el-select v-model="form.type" clearable placeholder="全部">
            <el-option label="设备离线预警" value="1"></el-option>
            <el-option label="租赁设备租期剩余20天预警" value="2"></el-option>
            <el-option label="设备滤芯余量预警" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发送时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex aic mgt-15 mgb-15 color052154">
      <span>短信发送条数：{{ allNum }}</span>
    </div>
    <!-- 表格 -->
    <div>
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="toPhones" label="电话号码"> </el-table-column>
        <el-table-column prop="warnType" label="预警类型">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.warnType == 1
                  ? '设备离线预警'
                  : scope.row.warnType == 2
                  ? '租赁设备租期剩余20天预警'
                  : scope.row.warnType == 3
                  ? '设备滤芯余量预警'
                  : '- -'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="发送状态">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.state == 1
                  ? '成功'
                  : scope.row.state == 2
                  ? '失败'
                  : '- -'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发送时间"> </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      form: {},
      tableData: [],
      allNum: 0,
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getList();
    this.getStat();
  },
  methods: {
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.communication
        .msgList({
          pageNum: this.page,
          pageSize: this.pageSize,
          phone: this.form.phone,
          warnType: this.form.type,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    getStat() {
      this.$api.communication.msgStat().then((res) => {
        if (res.code === 200) {
          this.allNum = res.data;
        }
      });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    reset() {
      this.form = {};
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
